import(/* webpackMode: "eager", webpackExports: ["default"] */ "/codebuild/output/src647305449/src/src/app/@travelCardModal/(...)travelCard/[id]/page.tsx");
